const BYTES_PER_MB = 1024 * 1024;

export const MAX_PDF_TEXT_FETCH_BYTES = 50 * BYTES_PER_MB;

export function parseContentLengthBytes(value: string | undefined): number | null {
  const normalized = value?.trim();
  if (!normalized || !/^\d+$/.test(normalized)) {
    return null;
  }

  const sizeBytes = Number(normalized);
  return Number.isFinite(sizeBytes) && sizeBytes >= 0 ? sizeBytes : null;
}

export function assertPdfFetchSizeWithinLimit(
  sizeBytes: number | null,
  maxBytes: number,
  url: string,
  source: 'Content-Length' | 'downloaded body'
): void {
  if (sizeBytes === null || sizeBytes <= maxBytes) {
    return;
  }

  throw new Error(
    `PDF is too large to fetch from ${url}: ${source} ${formatBytes(sizeBytes)} exceeds ${formatBytes(maxBytes)} limit.`
  );
}

function formatBytes(bytes: number): string {
  if (bytes >= BYTES_PER_MB) {
    return `${(bytes / BYTES_PER_MB).toFixed(1)}MB`;
  }
  if (bytes >= 1024) {
    return `${(bytes / 1024).toFixed(1)}KB`;
  }
  return `${bytes} bytes`;
}
